import { useEffect, useState } from "react";
import { SpeakButton } from "@/components/SpeakButton";
import { speak } from "@/lib/speech";

export const ChoiceExercise = ({ ex, lang, locked, onSubmit, onChange }) => {
  const [picked, setPicked] = useState(null);
  const isListen = ex.type === "listen";

  useEffect(() => {
    setPicked(null);
    if (isListen) setTimeout(() => speak(ex.audio_text, lang), 300);
  }, [ex, isListen, lang]);

  const choose = (opt) => {
    if (locked) return;
    setPicked(opt);
    onChange?.(opt);
  };

  return (
    <div>
      {isListen && (
        <div className="flex flex-col items-center gap-2 mb-6">
          <SpeakButton text={ex.audio_text} lang={lang} size="lg" testId="exercise-listen-play" />
          <span className="text-xs text-slate-500">Tap to listen again, or the snail for slow</span>
        </div>
      )}
      <div className="grid gap-3 sm:grid-cols-2">
        {ex.options.map((opt, i) => {
          const state = locked && onSubmit
            ? opt === ex.answer ? "opt-correct" : opt === picked ? "opt-wrong" : "opacity-60"
            : picked === opt ? "opt-selected" : "";
          return (
            <button
              key={opt}
              data-testid={`option-${i}`}
              onClick={() => choose(opt)}
              className={`option-card ${state}`}
            >
              <span className="h-7 w-7 shrink-0 rounded-lg border border-current/20 grid place-items-center text-xs font-bold opacity-70">{i + 1}</span>
              <span className="text-left">{opt}</span>
            </button>
          );
        })}
      </div>
      {onSubmit && !locked && (
        <button data-testid="exercise-check-button" disabled={!picked} onClick={() => onSubmit(picked === ex.answer, ex.answer)} className="btn-primary w-full mt-6">
          Check
        </button>
      )}
    </div>
  );
};
